import { useContext } from 'react';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useTranslation } from 'hooks';
import { LanguageContext } from 'context/Language';
import { trimHTML, trimText } from 'utils';
import { ArticleTag, ArticleTags } from 'types';

const ButtonLink = dynamic(() => import('components/NewsCard/ButtonLink'));
const Responsive = dynamic(() => import('components/Responsive'));
const Link = dynamic(() => import('components/Link'));

interface CardData {
  img: string;
  date?: string;
  title?: string;
  text?: string;
  tags: ArticleTag[];
  type?: string;
  href: string;
}

const SliderCard: React.FC<CardData> = ({ img, date, text, tags, href }) => {
  const { t } = useTranslation(['common']);
  const { lang } = useContext(LanguageContext);
  const newsFilter = tags.filter((el) =>
    [
      ArticleTags.NEWS,
      ArticleTags.ANNOUNCES,
      ArticleTags.WARNINGS,
      ArticleTags.PROMOTIONS,
    ].includes(el.code),
  );

  return (
    <>
      <Link href={href} className="slider-card">
        <div className="slider-card__box">
          {img && (
            <Responsive>
              <div className="slider-card__img-block">
                <Image src={img} layout="fill" objectFit="cover" />
              </div>
            </Responsive>
          )}

          <div className="card-header__box">
            <div className="title-block">
              {newsFilter && newsFilter.length > 0 && (
                <div className={cn(`title-block__text`, newsFilter[0]?.code)}>
                  <div className="title-text">{newsFilter[0]?.i18n[lang]}</div>
                </div>
              )}

              <div className="title-block__date">{date}</div>
            </div>

            {text && text.length > 0 && (
              <div
                className="slider-card__text-area"
                dangerouslySetInnerHTML={{ __html: trimText(trimHTML(text), 110) }}
              />
            )}
          </div>
        </div>

        <Responsive until="small-desktop">
          <ButtonLink className="slider-card__button" href={href} title={t('findOutMore')} />
        </Responsive>
      </Link>
    </>
  );
};

export default SliderCard;
